<template>
    <div class="news-template">
        <div class="news-template-header" v-bind:style="{ 'background-image': 'url(' + imageMainUrl + ')' }">
            <router-link class="news-template-header__close-btn-link" to="/news/newswire">
                <img class="news-template-header__close-btn" src="/assets/imgs/close.png" alt="Close">
            </router-link>
            <div class="news-template-header-content-wrapper">
              <div class="news-template-header-content">
                <div class="news-template-header-content-container">
                    <h1 class="news-template-header-title">{{ headline }}</h1>
                    <p class="news-template-description">{{ articleFull }}</p>
                  </div>
              </div>
            </div>
        </div>

        <div class="news-template-content">
            <p class="news-template-content__paragraph" v-for="paragraph in paragraphs" v-html=paragraph></p>
        </div>

        <div class="news-template-related">
            <h3 class="news-template-related__heading">Related news</h3>

            <ul class="news-template-related__list">
                <li v-for="related in relatedArray" class="news-template-related__item">
                    <div class="news-template-related__item-container">
                        <div class="news-template-related__item-heading-container">
                            <h2 class="news-template-related__item-heading" v-html="related.Headline"></h2>
                        </div>

                        <div class="news-template-related__item-paragraph-container">
                            <div class="news-template-related__item-paragraph-wrapper">
                                <p class="news-template-related__item-paragraph" v-html="related.ArticlePreview"></p>

                                <a v-if="related.ArticleLinkType === 'link'" class="news-template-related__item-link" :href=related.ArticleLink target="_blank">Read More</a>
                                <router-link v-else :to="'/news/newswire/' + related.Slug" class="news-template-related__item-link">Read More</router-link>
                            </div>
                        </div>

                        <img class="news-template-related__item-image" :src="related.ArticleImageThumbnail">
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<style scoped lang="less">
    @import "../less/breakpoints.less";

    .news-template-header {
        background-attachment: fixed;
        background-size: 100% auto;
        background-repeat: no-repeat;
        margin-bottom: 60px;
        overflow: hidden;
        padding-top: 0;
        position: relative;
    }

    .news-template-header__close-btn-link {
        display: block;
        left: 25px;
        position: absolute;
        top: 20px;
        z-index: 100;

        @media @breakpoint__mobile--large {
            left: 15px;
        }
    }

    .news-template-header__close-btn {
        cursor: pointer;
        display: block;
        width: 49px;
        z-index: 70;

        @media @breakpoint__mobile--large {
            width: 36px;
        }
    }

    .news-template-header__image {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 0;
    }

    .news-template-header-content-wrapper {
        background-color: rgba(0, 0, 0, 0.2);
        color: #ffffff;
        height: 100%;
        left: 50%;
        position: absolute;
        top: 0;
        transform: translateX(-50%);
        width: 100%;

        @media @breakpoint__tablet--small {
            background-color: #ffffff;
            color: #003a4a;
            position: static;
            transform: none;
        }
    }

    .news-template-header-content {
        align-items: center;
        display: flex;
        height: 100%;
        margin: auto;
        max-width: 1300px;
        width: 100%;
    }

    .news-template-header-content-container {
        max-width: 786px;
        padding: 50px 50px 0;

        @media @breakpoint__tablet--medium {
            padding: 50px 20px 0;
        }
    }

    .news-template-content {
        background-color: #ffffff;
        box-sizing: border-box;
        margin: 0 auto;
        max-width: 1300px;
        padding: 0 50px;
        position: relative;
        width: 100%;
        z-index: 10;

        @media @breakpoint__tablet--medium {
            padding: 0 20px;
        }
    }

    .news-template-header-title {
        display: inline-block;
        font-size: 50px;
        letter-spacing: 0.5px;
        margin-bottom: 20px;
        padding-bottom: 20px;
        position: relative;

        @media @breakpoint__tablet--medium {
            font-size: 40px;
        }

        &:after {
            bottom: 0;
            content: "";
            border-bottom: 4px solid red;
            position: absolute;
            left: 0;
            width: 100px;
        }
    }

    .news-template-description {
        font-size: 20px;
        letter-spacing: 0.7px;
        margin: 0;
    }

    .news-template-related {
        background-color: #ffffff;
        max-width: 1300px;
        margin: 0 auto 20px;
        position: relative;
        z-index: 10;
    }

    .news-template-related__heading {
        color: #003a4a;
        font-size: 30px;
        font-weight: 600;
        letter-spacing: 0.38px;
        margin: 0 50px 35px;
        opacity: 0;
        text-transform: uppercase;
        transform: translateY(50px);

        @media @breakpoint__tablet--medium {
            margin: 0 20px 35px;
        }
    }

    .news-template-related__list {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        width: 100%;
    }

    .news-template-related__item {
        box-sizing: border-box;
        display: inline-block;
        list-style-type: none;
        margin: 0 50px 50px;
        opacity: 0;
        transform: translateY(20px);
        width: calc(~"(100% / 3) - (100px / 3 * 2)");
        vertical-align: top;

        .news-template-related__item-image {
            display: block;
            width: 100%;
            height: 300px;
            object-fit: cover;
        }

        &:nth-child(3n+2) {
            margin: 0;
        }

        @media @breakpoint__tablet--medium {
            margin: 0 20px 20px;
            width: calc(~"(100% / 3) - (40px / 3 * 2)");
        }

        @media @breakpoint__tablet--small {
            padding: 0 20px 25px;
            margin: 0 !important;
            width: 100%;
        }
    }

    .news-template-related__item-container {
        -webkit-mask-image: -webkit-radial-gradient(white, black);
        background-color: #386572;
        border-radius: 55px;
        display: block;
        overflow: hidden;
        position: relative;

        @media @breakpoint__tablet--large {
            border-radius: 50px;
        }

        @media @breakpoint__tablet--medium {
            border-radius: 50px;
        }

        @media @breakpoint__tablet--small {
            border-radius: 50px;
        }

        &:before {
            content: "";
            background-color: #304449;
            height: 100%;
            left: 0;
            opacity: 0.72;
            position: absolute;
            transition: 0.3s opacity;
            top: 0;
            width: 100%;
        }

        &:hover {
            .news-template-related__item-heading-container {
                transform: translateY(-100%);
            }
            .news-template-related__item-paragraph-container {
                transform: translateY(-100%);
            }
        }

        @media @breakpoint__tablet--large {
            &:before {
                opacity: 0.6;
            }

            .news-template-related__item-heading {
                opacity: 1;
                transform: translateY(-50%);
                transition-delay: 0.1s;
            }
        }
    }

    .news-template-related__item-heading-container {
        height: 100%;
        left: 0;
        position: absolute;
        text-align: left;
        top: 0;
        transition: 0.5s transform;
        width: 100%;
        z-index: 10;
    }

    .news-template-related__item-heading {
        color: #fff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 22px;
        letter-spacing: 1px;
        margin: 0 auto;
        padding-bottom: 20px;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        width: 80%;

        &:after {
            bottom: 0;
            content: "";
            border-bottom: 4px solid red;
            position: absolute;
            left: 0;
            width: 30%;
        }

        @media @breakpoint__tablet--medium{
            font-size: 20px;
        }
    }

    .news-template-related__item-paragraph-container {
        height: 100%;
        left: 0;
        margin: 0 auto;
        position: absolute;
        text-align: left;
        right: 0;
        top: 100%;
        transition: 0.5s transform;
        width: 80%;
        z-index: 10;
    }

    .news-template-related__item-paragraph-wrapper {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }

    .news-template-related__item-paragraph {
        color: #fff;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-size: 16px;
        letter-spacing: 1px;
        line-height: 1.4;
        margin: 0 0 20px;
        position: relative;

        @media @breakpoint__tablet--large {
            font-size: 14px;
        }
    }

    .news-template-related__item-link {
        border: 1px solid #ffffff;
        border-radius: 5px;
        color: #ffffff;
        cursor: pointer;
        display: inline-block;
        font-size: 14px;
        letter-spacing: 1.2px;
        line-height: 23px;
        margin: 0;
        padding: 1px 5px 2px;
        text-decoration: none;
        text-transform: uppercase;
        transition: 0.5s all;

        &:focus {
            outline: none;
        }

        &:hover {
            background: #ffffff;
            color: #003a4a;
        }
    }
</style>

<style lang="less">
    @import "../less/breakpoints.less";

    .news-template-content__paragraph {
        color: #003a4a;
        font-size: 20px;
        letter-spacing: 0.7px;
        line-height: 1.6;
        margin: 0;
        opacity: 0;
        padding: 0 0 50px 0;
        transform: translateY(50px);

        @media @breakpoint__mobile--large {
            font-size: 16px;
            text-align: left;
        }

        strong {
            color: #e40046;
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        }

        img {
            border-radius: 55px;
            height: auto;
            width: 100%;
        }
    }
</style>

<script>
    export default {
        name: "newsTemplate",
        data() {
            return {
                articleFull : "",
                headline : "",
                imageMainUrl : "",
                paragraphs: [],
                relatedArray: []
            }
        },
        created: function()
        {
            var vm = this;
            vm.$parent.backgroundColor = "light";
            var testIfDataLoaded = setInterval(function()
            {
                if (!vm.isObjectEmpty(vm.$parent.modelNews))
                {
                    clearInterval(testIfDataLoaded);
                    vm.initContent(vm.$parent.modelNews);
                    vm.initSubTitle();
                }
            }, 500);
        },
        mounted : function()
        {
        },
        methods: {
            initContent: function(newsData)
            {
                var newsWireData = this.findObjectByKey(newsData, "Slug", this.$route.params.id);
                this.headline = newsWireData.Headline;
                this.articleFull = newsWireData.ArticleFull;
                this.imageMainUrl = newsWireData.ArticleImageMain;
                this.paragraphs = newsWireData.ArticleParagraphs;

                for (var i = 0; i < newsWireData.Related.length; i++)
                {
                    this.relatedArray.push(this.findObjectByKey(newsData, "Slug", newsWireData.Related[i].Slug));
                }

                var vm = this;
                setTimeout(function()
                {
                    vm.onEnter();
                }, 500);
            },
            initSubTitle : function() {
                document.querySelector(".header__logo-sub-title").innerHTML = "News";
                TweenMax.set(document.querySelector(".header__logo-sub-title-container"), {width: "auto"});
                TweenMax.from(document.querySelector(".header__logo-sub-title-container"), 0.3, {width: 0, delay: 0.2});
            },
            onEnter : function()
            {
                function getBgUrl(el)
                {
                    var bg = "";

                    if (el.currentStyle)
                    {
                        bg = el.currentStyle.backgroundImage;
                    }
                    else if (document.defaultView && document.defaultView.getComputedStyle)
                    {
                        bg = document.defaultView.getComputedStyle(el, "").backgroundImage;
                    }
                    else
                    {
                        bg = el.style.backgroundImage;
                    }

                    return bg.replace(/url\(['"]?(.*?)['"]?\)/i, "$1");
                }

                var image = document.createElement('img');
                image.src = getBgUrl(document.querySelector(".news-template-header"));
                image.onload = function ()
                {
                    var tl = new TimelineMax();
                    tl.to(".news-template-header", 0.7, {paddingTop: "48%", ease: Power3.easeOut});
                    tl.to(".news-template-header__close-btn", 0.6, {transform: "scale(1)", ease: Back.easeOut.config(2)}, "-=0.6");
                    tl.to(".news-template-content__paragraph", 0.4, {transform: "translateY(0)", opacity: "1"}, "-=0.4");
                    tl.to(".news-template-filters", 0.4, {transform: "translateY(0)", opacity: "1"}, "-=0.2");
                    tl.to(".news-template-related__heading", 0.4, {transform: "translateY(0)", opacity: "1"}, "-=0.2");
                    tl.staggerTo(".news-template-related__item", 0.5, {opacity: 1, transform: "translateY(0)", ease: Power2.easeOut}, 0.2, "-=0.2");
                };
            }
        },
        watch:
        {
            '$route' (to, from)
            {
                this.$parent.templateName = to.path;
            }
        }
    };
</script>
